module.exports = __webpack_public_path__ + "img/fences.f708b514.jpg";